const mapReturn = (returnData)=>{
    const filteredLineItems = returnData.order.lineItems.filter((lineItem)=>{
        var ref;
        return lineItem.sku || ((ref = lineItem.product) === null || ref === void 0 ? void 0 : ref.sku);
    });
    return {
        status: returnData.status,
        returnLabelUrl: returnData.returnLabelUrl,
        order: {
            orderNumber: returnData.order.orderNumber,
            lineItems: filteredLineItems.map((lineItem)=>{
                var ref;
                if (!lineItem.product) {
                    console.log(`Missing product information while requesting Returns line item for order ${returnData.order.orderNumber}`);
                    return {
                        displayName: '',
                        imageSrc: '',
                        quantity: lineItem.quantity,
                        sku: lineItem.sku,
                        lineItemNumber: lineItem.lineItemNumber,
                        isReturnable: lineItem.isReturnable
                    };
                }
                const { product  } = lineItem;
                return {
                    displayName: product.displayName,
                    imageSrc: product.media.images.length ? (ref = product.media.images[0]) === null || ref === void 0 ? void 0 : ref.url : undefined,
                    quantity: lineItem.quantity,
                    sku: product.sku,
                    lineItemNumber: lineItem.lineItemNumber,
                    isReturnable: lineItem.isReturnable
                };
            })
        }
    };
};

export { mapReturn };
//# sourceMappingURL=map-return.js.map
